import React from "react";

const GOQiiButton = ({
  text = "Button",
  size = "small",                    
  color = "green",                   
  solid = true,                     
  shape = "rectangle",              
  font = "regular",              
  iconLeft,
  iconRight,
  iconTop,
  iconBottom,
  onClick,
}) => {


  const toCamelCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  const padding = "5px 20px 5px 20px";

  const borderRadius = shape === "rounded_edges" ? "40px" : "6px";


  const stylesByColor = (() => {
    if (color === "green") {
      return solid
        ? { background: "#35b400", color: "#FFF", border: "2px solid #35b400" }
        : { background: "transparent", color: "#35b400", border: "2px solid #35b400" };
    }

    if (color === "grey") {
      return solid
        ? { background: "#A9A9A9", color: "#FFF", border: "2px solid #A9A9A9" }
        : { background: "transparent", color: "#A9A9A9", border: "2px solid #A9A9A9" };
    }

    return {};
  })();


  const fontStyles = {
    regular: { fontWeight: 400 },
    light: { fontWeight: 300 },
    medium: { fontWeight: 500 },
    bold: { fontWeight: 400 },
    autobus: { fontFamily: "Autobus, sans-serif" },
  };

  const buttonStyle = {
    padding,
    minWidth: "120px",
    borderRadius:"20px",
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    textAlign: "center",
    transition: "transform 0.2s",
    ...stylesByColor,
    ...fontStyles[font],
  };

  
  const iconStyle = {
    width: 18,
    height: 18,
  };

  return (
    <button
      onClick={onClick}
      style={buttonStyle}
      onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.96)")}
      onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      {iconTop && <img src={iconTop} style={{ ...iconStyle, marginBottom: 6 }} alt="" />}

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {iconLeft && <img src={iconLeft} style={iconStyle} alt="" />}
        {toCamelCase(text)}
        {iconRight && <img src={iconRight} style={iconStyle} alt="" />}
      </div>

      {iconBottom && <img src={iconBottom} style={{ ...iconStyle, marginTop: 6 }} alt="" />}
    </button>
  );
};

export default GOQiiButton;
